import React from 'react'

import { useSelector, useDispatch } from 'react-redux'

import queryString from 'query-string'

import { Router, Route, Redirect } from 'react-router-dom'

import { LoadingIndicator, PrintCapturesPreview } from '../ui'

import { resetPasswordRequired } from '../../redux/actions'

import { History, updateUserPassword } from '../../utils'

import { NotificationToast } from '../ui/tools/Toast'

import Login from '../../pages/Login'
import Logout from '../../pages/Logout'
import PasswordReset from '../../pages/PasswordReset'
import SSOResponse from '../../pages/SSOResponse'
import SessionResponse from '../../pages/SessionResponse'
import CapturePageBody from '../../pages/CapturePageBody'
import GridView from '../../pages/GridView'
import ListView from '../../pages/ListView'
import SingleView from '../../pages/SingleView'
import DashboardView from '../../pages/DashboardView'
import ReportsView from '../../pages/ReportsView'
import Links from '../../pages/Links'
import MobileSingle from '../../pages/MobileSingleView'
// import Landing from '../../pages/Landing'
import ForcePasswordReset from '../../pages/ForcePasswordReset'

import { setPageView } from '../../redux/actions/select'

import log from 'loglevel'
import * as rdd from 'react-device-detect'

const Routes = props => {
  const dispatch = useDispatch()
  const { isAuthenticated, tokenExp, passwordResetRequired, token, accountId, supervisorID, defaultPage, defaultView } = useSelector(state => state.auth)
  const fromLink = useSelector(state => state.selection.FromLink)
  const expiration = tokenExp

  const handleResetPassword = async (oldPassword, newPassword, confirmPassword) => {
    if (newPassword === confirmPassword) {
      const status = await updateUserPassword(token, accountId, supervisorID, oldPassword, newPassword)

      if (status === true) {
        resetPasswordRequired()
        NotificationToast(false, 'Password updated successfully!')
        await dispatch(resetPasswordRequired())
        return findDefaultRoute()
      } else {
        NotificationToast(true, 'Incorrect password entered!')
        return false
      }
    } else {
      NotificationToast(true, 'Passwords do not match!')
      return false
    }
  }

  const findDefaultRoute = (props) => {
    if (props && props.location && props.location.state && props.location.state.from) {
      return <Redirect to={props.location.state.from.url} />
    }
    // log.info(defaultPage)
    if (defaultPage === 'D') {
      dispatch(setPageView('C'))
      return <Redirect to='/dashboard' />
    } else if (defaultPage === 'C') {
      if (defaultView === 'L') {
        return <Redirect to='/captures?view=list&page=1&activeCapture=0&default=1' />
      } else if (defaultView === 'G') {
        return <Redirect to='/captures?view=grid&page=1&activeCaptures=[]&default=1' />
      } else {
        return <Redirect to='/captures?view=single&capture=1&default=1' />
      }
    } else {
      log.warn('Could not find default page. Redirecting to dashboard...')
      return <Redirect to='/dashboard' />
    }
  }

  return (
    <>
      <LoadingIndicator />
      {isAuthenticated && expiration ? <SessionResponse expiration={expiration} /> : <></>}
      <Router history={History}>
        <Route path='/' exact render={() => (isAuthenticated ? findDefaultRoute() : <Redirect to='/login' />)} />
        <Route path='/login' exact render={(props, match) => (!isAuthenticated ? <Login location={props.location} history={props.history} match={match} /> : findDefaultRoute(props))} />
        <Route path='/logout' exact render={(props, match) => (<Logout location={props.location} history={props.history} match={match} />)} />
        <Route
          path='/captures' exact render={({ match, location, history }) => {
            if (isAuthenticated) {
              const parsed = queryString.parse(location.search)
              if (rdd.isMobile) {
                return <MobileSingle match={match} location={location} fromLink={fromLink} />
              } else {
                return (
                  <>
                    <CapturePageBody fetchCaptures fromLink={fromLink} from={history} />
                    {
                      parsed.view === 'list'
                        ? <ListView match={match} location={location} fromLink={fromLink} />
                        : parsed.view === 'single'
                          ? <SingleView match={match} location={location} fromLink={fromLink} />
                          : <GridView match={match} location={location} fromLink={fromLink} />
                    }
                  </>
                )
              }
            } else {
              return <Redirect to='/login' />
            }
          }}
        />
        <Route
          path='/dashboard' exact render={() => {
            if (isAuthenticated) {
              if (rdd.isMobile) {
                return <Redirect to='/captures' />
              } else {
                return (
                  <>
                    <CapturePageBody fromLink={fromLink} />
                    <DashboardView fromLink={fromLink} />
                  </>
                )
              }
            } else {
              return (
                <Redirect to='/login' />
              )
            }
          }}
        />
        <Route
          path='/reports' exact render={() => {
            if (isAuthenticated) {
              return (
                <>
                  <CapturePageBody fetchCaptures={false} />
                  <ReportsView fromLink={fromLink} />
                </>
              )
            } else {
              return (
                <Redirect to='/login' />
              )
            }
          }}
        />
        <Route
          path='/password-reset' exact render={() => {
            return (
              <>
                <PasswordReset />
              </>
            )
          }}
        />
        <Route path='/signin' component={SSOResponse} />
        <Route
          path='/link/:linkID'
          render={(props) => !isAuthenticated ? <Redirect to={{ pathname: '/login', state: { from: props.match } }} /> : <Links />}
        />
        <Route path='/captures/print' exact component={PrintCapturesPreview} />
      </Router>
      {/* <Landing
        landingModal={firstTimeLogin && !passwordResetRequired}
        toggleLandingModal={(e) => { e.preventDefault(); dispatch(resetFirstTimeLogin()); return <Redirect to='/dashboard' /> }}
      /> */}
      <ForcePasswordReset
        passwordModal={passwordResetRequired === 1}
        onResetPassword={handleResetPassword}
      />
    </>
  )
}

export default Routes
